import * as React from "react";
import { NavMain } from "./NavMain";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "../ui/sidebarNew";
import { ChevronLeft, ChevronRight, Link } from "lucide-react";
import { AdminNav, BrandNav, InfluencerNav } from "../Constants/AppConstant";
import { useNavigate } from "react-router-dom";
import { BrandSidebar } from "./BrandSidebar";

export function AppSidebar({
  user,
  userInfo,
  profiles,
  cartItem,
  closeCartPanel,
  setModalNotification,
  setModal,
  NotifModul,
  goToPricing,
}) {
  const navigate = useNavigate();
  const { state, toggleSidebar } = useSidebar();
  const isCollapsed = state === "collapsed";
  const ActiveSideBar =
    user?.data?.active_role === 3
      ? BrandNav
      : user?.data?.active_role === 2
      ? AdminNav
      : InfluencerNav;
  const isBrand = user?.data?.active_role === 3;

  const handleLogoClick = () => {
    if (user?.data?.active_role === 3) {
      navigate("/brand/dashboard");
    } else if (user?.data?.active_role === 2) {
      navigate("/admin/dashboard");
    } else if (user?.data?.active_role === 1) {
      navigate("/influencer/dashboard");
    } else {
      window.location.href = "https://app.tamayou.com/";
    }
  };

  if (user?.data?.active_role === 3) {
    return <BrandSidebar user={user} handleAnchorClick={() => {}} />;
  }

  return (
    <Sidebar
      className={`${
        isCollapsed ? "!w-20" : "!w-64"
      } z-[950] transition-all duration-300 h-screen`}
      collapsible="icon"
      style={{
        background:
          "linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)",
        borderRight: "1px solid #e2e8f0",
        boxShadow: "4px 0 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      {/* Header with glassmorphism effect */}
      <SidebarHeader
        className="h-16 flex items-center justify-center relative"
        style={{
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div
          className={`flex items-center w-full relative ${
            isCollapsed ? "justify-center" : "justify-between pr-4 pl-6"
          }`}
        >
          <div
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => handleLogoClick()}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center shadow-lg transform group-hover:scale-105 transition-all duration-300"
              style={{
                background:
                  "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)",
                boxShadow: "0 4px 16px rgba(16, 185, 129, 0.3)",
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/favicon/favicon.ico"}
                className="h-6 w-6 drop-shadow-md"
                alt="Logo"
              />
            </div>
            {!isCollapsed && (
              <span
                className="font-bold text-xl tracking-wide"
                style={{
                  background:
                    "linear-gradient(90deg, #059669, #10b981, #34d399)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                TAMA
              </span>
            )}
          </div>
          <button
            className="w-6 h-6 rounded-full flex items-center justify-center absolute -right-4 top-1/2 transform -translate-y-1/2 z-[100] transition-all duration-300 hover:scale-110"
            style={{
              background: "linear-gradient(135deg, #10b981, #059669)",
              boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
              border: "2px solid #ffffff",
            }}
            onClick={toggleSidebar}
          >
            {isCollapsed ? (
              <ChevronRight className="w-4 h-4 text-white drop-shadow" />
            ) : (
              <ChevronLeft className="w-4 h-4 text-white drop-shadow" />
            )}
          </button>
        </div>
      </SidebarHeader>

      {/* Content area */}
      <SidebarContent
        className={`${
          isCollapsed ? "px-2 py-4" : "px-3 py-4"
        } space-y-1 overflow-y-auto`}
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>{`
          .sidebar-content::-webkit-scrollbar { display: none; }
        `}</style>
        <NavMain
          items={ActiveSideBar}
          user={user}
          userInfo={userInfo}
          profiles={profiles}
          cartItem={cartItem}
          closeCartPanel={closeCartPanel}
          setModalNotification={setModalNotification}
          setModal={setModal}
          NotifModul={NotifModul}
          goToPricing={goToPricing}
        />
      </SidebarContent>

      {/* Footer with elegant styling */}
      <SidebarFooter
        className={`${isCollapsed ? "px-2" : "px-4"} py-4`}
        style={{
          borderTop: "1px solid #e2e8f0",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(8px)",
        }}
      >
        {!isCollapsed && (
          <div className="space-y-3">
            <div className="flex justify-center flex-wrap gap-x-4 gap-y-1 text-xs">
              <a
                href="https://tamayou.com/tama-privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-emerald-600 transition-colors duration-200 hover:underline underline-offset-2"
              >
                Privacy
              </a>
              <a
                href="https://tamayou.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-emerald-600 transition-colors duration-200 hover:underline underline-offset-2"
              >
                Terms
              </a>
              <a
                href="https://tamayou.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-emerald-600 transition-colors duration-200 hover:underline underline-offset-2 flex items-center gap-1"
              >
                Corp Site
                <Link className="w-3 h-3" />
              </a>
            </div>
            <div className="text-xs text-center font-medium text-slate-400">
              © {new Date().getFullYear()} TAMA
            </div>
          </div>
        )}
        {isCollapsed && (
          <div className="text-xs text-center text-slate-400">©</div>
        )}
      </SidebarFooter>
    </Sidebar>
  );
}
